import React from 'react';
import { bool, node, string, oneOf } from 'prop-types';
import styled from 'styled-components';

const StyledList = styled.ul`
    padding-inline-start: 16px;
    text-align: left;
    width: fit-content;
    display: flex;
    flex-direction: column;
    gap: 16px;
    p {
        margin-bottom: 0;
        margin-top: 0;
    }
    ${({ centerAlignText }) => centerAlignText && `margin: auto;`}
    ${({ markerStyle }) =>
        markerStyle === 'numbered' && 'list-style-type: number;'}
    ${({ listCheckMarks }) =>
        listCheckMarks &&
        `
            padding-inline-start: 0;
            gap:12px;

        `}
`;

const List = ({
    markerStyle,
    listCheckMarks,
    centerAlignText,
    listTickVariant = 'green',
    children
}) => (
    <StyledList
        markerStyle={markerStyle}
        listCheckMarks={listCheckMarks}
        centerAlignText={centerAlignText}>
        {listCheckMarks
            ? React.Children.map(children, (child) => {
                  if (React.isValidElement(child)) {
                      return React.cloneElement(child, {
                          listCheckMarks,
                          listTickVariant
                      });
                  }
                  return child;
              })
            : children}
    </StyledList>
);

List.propTypes = {
    children: node.isRequired,
    markerStyle: string,
    listCheckMarks: bool,
    centerAlignText: bool,
    listTickVariant: oneOf(['blue', 'green'])
};
List.defaultProps = {
    markerStyle: 'bulleted',
    listCheckMarks: false,
    centerAlignText: false,
    listTickVariant: 'green'
};
export default List;
